import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import Laboratory from '@/views/Laboratory'
import Patent from '@/views/Patent'
import Refill from '@/views/Refill'
import Video from '@/views/video'
import Production from '@/views/Production'
import Products from '@/views/Products'
import Product from '@/views/Product'
import TradeShow from '@/views/TradeShows'
import Contact from '@/views/Contact'
import Search from '@/views/Search'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    name: 'home',
    component: Home
  },
  {
    path:'/About',
    name: 'about',
    component: About
  },
  {
    path:'/Laboratory',
    name: 'laboratory',
    component: Laboratory
  },
  {
    path:'/Patent',
    name: 'patent',
    component: Patent
  },
  {
    path:'/Production',
    name: 'production',
    component: Production
  },
  {
    path:'/Products',
    name: 'products',
    component: Products
  },
  {
    path:'/Product/:name',
    name: 'product',
    component: Product
  },
  {
    path:'/Video',
    name: 'video',
    hash: '*',
    component: Video
  },
  {
    path:'/trade_shows',
    name: 'trade-shows',
    component: TradeShow
  },
  {
    path:'/Contact',
    name: 'contact',
    component: Contact
  },
  {
    path:'/Search',
    name: 'search',
    component: Search
  },
  {
    path:'*',
    name: 'any',
    component: Home
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      setTimeout(() => {
        window.scrollTo(0, document.querySelector(to.hash).offsetTop+document.querySelector('.navbar').clientHeight)
      }, 0);
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})

export default router
